const assetUrl = (path) => {
  return `${process.env.VUE_APP_ASSETS_URL}/${path}`
}

const assetsHost = () => {
  return process.env.VUE_APP_ASSETS_URL
}

export default {
  assetUrl,
  assetsHost
}
